import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface ChatFolder {
  id: string
  name: string
  icon: string
}

interface FoldersState {
  folders: ChatFolder[]
  addFolder: (name: string, icon: string) => void
  removeFolder: (id: string) => void
  updateFolder: (id: string, name: string, icon: string) => void
}

const DEFAULT_FOLDERS: ChatFolder[] = [
  { id: 'inbox', name: 'All', icon: '💬' },
  { id: 'archive', name: 'Archive', icon: '📁' },
]

export const useFoldersStore = create<FoldersState>()(
  persist(
    (set) => ({
      folders: DEFAULT_FOLDERS,

      addFolder: (name, icon) =>
        set((s) => ({
          folders: [...s.folders, { id: `custom_${Date.now()}`, name, icon }],
        })),

      removeFolder: (id) =>
        set((s) => ({
          folders: s.folders.filter((f) => f.id !== id || f.id === 'inbox' || f.id === 'archive'),
        })),

      updateFolder: (id, name, icon) =>
        set((s) => ({
          folders: s.folders.map((f) => (f.id === id ? { ...f, name, icon } : f)),
        })),
    }),
    { name: 'ggram-folders' }
  )
)
